/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
declare const _RejectedTombstoneContainer_comment$ref: unique symbol;
export type RejectedTombstoneContainer_comment$ref = typeof _RejectedTombstoneContainer_comment$ref;
export type RejectedTombstoneContainer_comment = {
    readonly id: string;
    readonly " $refType": RejectedTombstoneContainer_comment$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "RejectedTombstoneContainer_comment",
    "type": "Comment",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '5a52b044795c30dd53dff01d3c2d4095';
export default node;
